import { NavContainer, StorageVolumnBox } from "../../style/lauout/layout";
import menuData from "../../components/layout/menu.data.json";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuthStore } from "../../atoms/user.auth.store";
import { useEffect, useState } from "react";
import { fetchVolumeState, VolumeStateResponse } from "../../api/admin";

const formatStorageSize = (value: number) => {
  if (!Number.isFinite(value) || value <= 0) return "0 B";

  const units = ["B", "KB", "MB", "GB", "TB"];
  const unitIndex = Math.min(
    Math.floor(Math.log(value) / Math.log(1000)),
    units.length - 1,
  );
  const size = value / 1000 ** unitIndex;
  const formattedSize =
    size >= 10 || unitIndex === 0 ? Math.round(size) : Number(size.toFixed(1));

  return `${formattedSize} ${units[unitIndex]}`;
};

const NavMenu = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [volumeState, setVolumeState] = useState<VolumeStateResponse | null>(
    null,
  );
  const [volumeLoading, setVolumeLoading] = useState(false);
  const [volumeError, setVolumeError] = useState(false);

  const currentPath = location.pathname;
  const { role } = useAuthStore(); // ✅ 리코일에서 role 꺼내기

  const userId = localStorage.getItem("userId"); // ✅ localStorage에서 userId 가져오기
  const userMenuPaths = ["/backup", "/db", "/image"];
  const usedVolume = volumeState?.used ?? 0;
  const provisionedVolume = volumeState?.provisioned ?? 0;
  const usagePercent =
    provisionedVolume > 0
      ? Math.min((usedVolume / provisionedVolume) * 100, 100)
      : 0;

  // ✅ role이 'user'인 경우 백업 관련 메뉴만 필터링
  const filteredMenu = menuData.filter((item) => {
    if (role === "admin") return true; // 전체 메뉴
    if (role === "user") return userMenuPaths.includes(item.path);
    return false; // role이 null이면 아무 것도 표시하지 않음
  });

  useEffect(() => {
    if (role !== "admin" || !userId) {
      setVolumeState(null);
      return;
    }

    const loadVolumeState = async () => {
      setVolumeLoading(true);
      setVolumeError(false);

      try {
        const response = await fetchVolumeState(userId);
        setVolumeState(response);
      } catch (err) {
        setVolumeError(true);
      } finally {
        setVolumeLoading(false);
      }
    };

    loadVolumeState();
  }, [role, userId]);

  return (
    <NavContainer>
      <ul>
        {filteredMenu.map((item, index) => {
          const isActive =
            currentPath === item.path ||
            currentPath.startsWith(item.path + "/");

          return (
            <li
              key={index}
              className={isActive ? "active" : ""}
              onClick={() => {
                if (role === "admin") {
                  navigate(item.move_path);
                } else if (role === "user" && userId) {
                  navigate(`${item.path}/device/${userId}`);
                }
              }}
            >
              <div className="item-box">
                <div className="icon-box">
                  {isActive ? (
                    <img src={item.active_icon} alt={item.name} />
                  ) : (
                    <img src={item.icon} alt={item.name} />
                  )}
                </div>
                <span>{item.name}</span>
              </div>
            </li>
          );
        })}
      </ul>
      {role === "admin" && (
        <StorageVolumnBox>
          <div className="inner">
            <div className="storage-title">스토리지 사용량</div>
            <div className="storage-volume">
              {volumeLoading ? (
                "불러오는 중..."
              ) : volumeError ? (
                "조회 실패"
              ) : (
                <>
                  <span>{formatStorageSize(usedVolume)}</span>
                  <span className="divider">/</span>
                  <span>{formatStorageSize(provisionedVolume)}</span>
                </>
              )}
            </div>
            <div className="storage-progress" aria-hidden="true">
              <div
                className="storage-progress-bar"
                style={{ width: `${usagePercent}%` }}
              />
            </div>
            {!volumeLoading && !volumeError && (
              <div className="storage-percent">{usagePercent.toFixed(1)}%</div>
            )}
          </div>
        </StorageVolumnBox>
      )}
    </NavContainer>
  );
};

export default NavMenu;
